import React, { ChangeEvent, useEffect, useState } from 'react'
import {
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CButton,
  CCol,
  CFormSelect,
  CRow,
} from '@coreui/react-pro'
import { Button, Flex, Image, notification, Upload } from 'antd'
import { $error, addWinners, addWinnersSubmit } from './model'
import { NotificationPlacement } from 'antd/es/notification/interface'
import { useUnit } from 'effector-react'
import { prizeTypes } from './constants'
import { AxiosError } from 'axios'
import { setError } from '../../../../translations/services/edit/model'

type Props = {
  isVisible: boolean
  onClose: () => void
}

export const AddWinnersModal: React.FC<Props> = ({ isVisible, onClose }) => {
  const [dataWinners, setDataWinners] = useState<{
    prizeType: string
    tickets: number[]
  }>({
    prizeType: 'imac',
    tickets: [],
  })

  const [api, contextHolder] = notification.useNotification()

  const saveError = useUnit($error)

  addWinners.doneData.watch((result) => {
    if (result) {
      onClose()
    }
  })

  const openNotification = (placement: NotificationPlacement) => {
    api.error({
      message: `Error`,
      description: `${saveError.message}`,
      placement,
    })
  }

  useEffect(() => {
    if (saveError.code !== 0) {
      openNotification('topRight')
    }
  }, [saveError])

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const value = event.currentTarget.value

    setDataWinners((prev) => ({
      ...prev,
      prizeType: value,
    }))
  }

  return (
    <CModal visible={isVisible} onClose={onClose}>
      {contextHolder}
      <CModalHeader>
        <CModalTitle>Add winners</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CRow className="mb-3">
          <CCol sm={7}>
            <CFormSelect
              label="Prize type"
              name="prizeType"
              value={dataWinners.prizeType}
              onChange={handleChange}
              required
            >
              {prizeTypes.map((language) => (
                <option value={language.value}>{language.label}</option>
              ))}
            </CFormSelect>
          </CCol>
        </CRow>
        <CRow className="mb-3">
          <Upload
            accept=".csv"
            showUploadList={true}
            onRemove={() => {
              setDataWinners((prevState) => ({
                ...prevState,
                tickets: [],
              }))
            }}
            beforeUpload={(file) => {
              const reader = new FileReader()

              reader.onload = (e) => {
                try {
                  // @ts-ignore
                  const result = e.target?.result as string

                  setDataWinners((prevState) => ({
                    ...prevState,
                    tickets: result
                      .replaceAll('\r', '')
                      .split('\n')
                      .filter((item) => Boolean(item))
                      .map((item) => Number(item)),
                  }))
                } catch (err) {
                  const error = err as AxiosError
                  setError({ message: error.message, code: 404 })
                }
              }
              reader.readAsText(file)

              return false
            }}
          >
            <Button>Click to Upload</Button>
          </Upload>
        </CRow>
        <CButton
          className="float-lg-end"
          onClick={() => addWinnersSubmit(dataWinners)}
        >
          Submit
        </CButton>
      </CModalBody>
    </CModal>
  )
}
